
import { Component, Vue, Watch } from 'vue-property-decorator'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { FavorSubjectIVO, FavorSubjectOVO } from '@/views/biz/omr/vo/Omr.vo'
import CommonUtils from '@/common-utils'
import axios from 'axios'
import Constants from '@/constants';

@Component
export default class OmrSearch extends Vue {
  tab = null;

  // 시험유형
  testTypes = [
    {text: '대체시험', value: '3'},
    {text: '기말시험', value: '4'},
    {text: '하계시험', value: '5'},
    {text: '동계시험', value: '6'},
  ];
  // 학기
  semesters = [
    {text: '1', value: '1'},
    {text: '2', value: '2'},
  ];

  member: MemberVO = {} as MemberVO;
  searchIVO: CommonSearchIVO = {} as CommonSearchIVO;
  subjects: Array<CommonSearchOVO> = [];
  subjectName = '';
  validForm = false;
  latestSubjectList = [] as Array<CommonSearchOVO>;
  currentExamNm;
  deleteTargetList: Array<FavorSubjectOVO> = [] as Array<FavorSubjectOVO>;

  // 즐겨찾기 목록
  favorSubejctList: Array<FavorSubjectOVO> = [] as Array<FavorSubjectOVO>;

  // 검색 필터 적용 결과
  filteredSubjects = [] as Array<CommonSearchOVO>;

  // 과목 선택
  selectedSubject(item: CommonSearchOVO): void {
    if(!this.member.mbrId) {
      this.$toast('로그인이 필요해요');
      return;
    }

    this.putLatestSearch(item);
    this.selectSubject(item);
  }

  // 선택한 기출문제 정보 저장
  selectSubject(item: CommonSearchOVO): void {
    const param: MemberVO = {} as MemberVO;
    param.meExam = item.emExam;
    param.meSemester = item.emSemester;
    param.meSmNo = item.smNo;

    axios.post('/member/exam', param)
    .then(r => {
      this.$router.push({name: 'OmrMain'})
    })
  }

  // 최근 검색 기록 저장
  putLatestSearch(item: CommonSearchOVO): void {
    this.latestSubjectList.unshift(item)
    CommonUtils.putLocalStorageObject(Constants.LATEST_SEARCH_SUBEJCTS, {items: this.latestSubjectList});
  }

  // 선택한 검색필터 - 시험유형
  currentSearchExamNm() {
    const temp = this.testTypes.filter(val => val.value == this.searchIVO.emExam);
    this.currentExamNm = `${temp.length ? temp[0].text: ''}`
  }

  // 최근 검색 기록 삭제
  deleteLatestSearch(item: CommonSearchOVO): void {
    this.latestSubjectList = this.latestSubjectList.filter(val => {
      if(val.smNo != item.smNo) {
        return val;
      } else {
        if(val.emExam != item.emExam && val.emSemester != item.emSemester) {
          return val;
        }
      }
    });
    CommonUtils.putLocalStorageObject(Constants.LATEST_SEARCH_SUBEJCTS, {items: this.latestSubjectList});
  }

  // 검색
  search(): void {
    // 동계 또는 하계일 경우
    // 동계는 2학기로 고정 , 하계는 1학기로 고정
    if(this.searchIVO.emExam == '5' || this.searchIVO.emExam == '6') {
      this.searchIVO.emSemester = (parseInt(this.searchIVO.emExam) - 4).toString();
    } else {
      this.searchIVO.emExam || (this.searchIVO.emExam = '3');
      this.searchIVO.emSemester || (this.searchIVO.emSemester = '1');
    }

    this.currentSearchExamNm();

    axios.get('/omr/subjects', {params: this.searchIVO})
    .then(r => {
      this.subjects = r.data;
      this.filteredSubjects  = this.subjects;
    })
  }

  // 즐겨찾기 목록 조회
  getFavorSubjects() {
    axios.get('omr/favors')
    .then(r => {
      this.deleteTargetList = [];
      this.favorSubejctList = r.data;
    })
  }

  // 즐겨찾기 해제
  async deleteFavorSubjectList() {
    const res =  await this.$confirm('즐겨찾기를 해제하시겠어요?', CommonUtils.baseConfirmOption);
    if(res) {
      axios.put('omr/favors', this.deleteTargetList)
      .then(r => {
        this.getFavorSubjects();
        this.search();
        r.data && this.$toast('즐겨찾기가 해제되었어요');
      })
    }
  }

  // 즐겨찾기 등록 및 해제
  toggleFavorSubject(item: CommonSearchOVO): void {
    axios.post('omr/favor', item)
    .then(r => {
      r.data.register ? this.$toast('즐겨찾기로 등록했어요'): this.$toast('즐겨찾기가 해제되었어요');
      item.fsNo = r.data.fsNo;
      this.getFavorSubjects();
    })
  }

  @Watch('subjectName')
  getSubject(ev: any) {
    const val = ev;
    if (val && val.trim()) {
      this.filteredSubjects = this.subjects.filter((item) => item.smNm.indexOf(val.toUpperCase()) > -1 );
    } else {
      this.filteredSubjects =  this.subjects;
    }
  }

  created(): void {
    this.latestSubjectList = (CommonUtils.getLocalStorageObject(Constants.LATEST_SEARCH_SUBEJCTS) as any).items;
    if(!this.latestSubjectList || !this.latestSubjectList.length) {
      const init = {items: []};
      CommonUtils.putLocalStorageObject(Constants.LATEST_SEARCH_SUBEJCTS, init)
      this.latestSubjectList = (CommonUtils.getLocalStorageObject(Constants.LATEST_SEARCH_SUBEJCTS) as any).items;
    }

    axios.get('/member')
    .then(r => {
      if(r.data) {
        this.member = r.data;
      }
    })

    this.search();
    this.getFavorSubjects();
  }
}
